import { render, staticRenderFns } from "./batchBulkShelves.vue?vue&type=template&id=c145540a&scoped=true"
import script from "./batchBulkShelves.vue?vue&type=script&lang=js"
export * from "./batchBulkShelves.vue?vue&type=script&lang=js"
import style0 from "./batchBulkShelves.vue?vue&type=style&index=0&id=c145540a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c145540a",
  null
  
)

export default component.exports